export const DEFAULT_AUD = "loyalty-web";
export const DEFAULT_KFP_CID = "12840";
export const DEFAULT_CAPTCHA_KEY = "aHJpeQ9SXVGPgiZ0GkGyJb30muovjyi555n1X8KL";
